/**
 * EventsList page
 */
class EventsList {

    constructor(url, settings) {
        this.locked=false;
        this.scrollThrottle=null;

        this.filtered=false;
        this.loadData={ pageId: 1 };
        this.loadDataQuery='all_events';
        this.page=1;

        this.url = url;
        this.initLayout();
        this.settings = (settings) ? settings : {};
    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

    initLayout() {
        var that = this;

        this.buttonMore = $('a.more');
        this.list = $('.events-list .list');
        this.loader = $('div.loader');
        this.message = $('div.message');

        if($('form#filter-events')[0]) {
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);

            var datepickerOptions = {
                format: 'dd.mm.yyyy',
                weekStart: 1,
                onRender: function(date) { return date.valueOf() < today.valueOf() ? 'disabled' : ''; },
                leftPosition: function() { return Math.round(($(window).width() - 980) / 2 + 750); }
            };

            this.filterForm = $('form#filter-events', 'section.events-list');
            this.filterStartDate = $('input.start-date', this.filterForm);
            this.filterEndDate = $('input.end-date', this.filterForm);

            this.filterStartDate.datepicker(datepickerOptions)
                .on('show', function() { window.evedo.disablePageScrolling(); })
                .on('hide', function() { window.evedo.enablePageScrolling(); });

            this.filterEndDate.datepicker(datepickerOptions)
                .on('show', function() { window.evedo.disablePageScrolling(); })
                .on('hide', function() { window.evedo.enablePageScrolling(); });

            $('button.toggle', this.filterForm).click(function() {
                if(!that.filterForm.hasClass('period')) {
                    that.filterForm.addClass('period');
                    that.filterStartDate.attr('placeholder', that.settings.translations.startDate);
                }
                else {
                    that.filterForm.removeClass('period');
                    that.filterStartDate.attr('placeholder', that.settings.translations.filterByDate);
                }
            });

            this.filterForm.submit(function() {
                that.filterFormSubmitHandler();
                return false;
            });
        }

        this.buttonMore.click(function() {
            that.loadEvents();
            return false;
        });

        if($(document).height() > $(window).height()) {
            $(window).bind('scroll', { eventsList: this }, this.scrollHandler);
        }

        $('div.container').addClass('low');
    }

    filterFormSubmitHandler() {
        var that = this;

        if((!this.filterStartDate.val().length && !this.filterEndDate.val().length) || (!this.filterStartDate.val().length && !this.filterForm.hasClass('period'))) {
            query = 'all_events';
        }
        else {
            if(!this.filterForm.hasClass('period')) {
                query = 'single_' + this.filterStartDate.val();
            }
            else {
                query = 'period_' + this.filterStartDate.val() + '_' + this.filterEndDate.val();
            }
        }

        if(query != this.loadDataQuery) {
            if(this.locked) return;
            this.lock();

            $(window).unbind('scroll', this.scrollHandler);

            this.buttonMore.hide();
            this.filterStartDate.datepicker('hide');
            this.filterEndDate.datepicker('hide');

            this.list.html('');
            this.loader.addClass('reset').show();
            this.message.hide();

            this.page = 0;

            window.setTimeout(function() {
                that.loadEvents();
            }, 200);
        }
    }

    scrollHandler(e) {
        var that = e.data.eventsList;

        window.clearTimeout(that.scrollThrottle);
        that.scrollThrottle = window.setTimeout(that.scrollHandlerCallback, 100, that);
    }

    scrollHandlerCallback(that) {
        if($(window).scrollTop() + $(window).height() == $(document).height()) {
            $(window).unbind('scroll', that.scrollHandler);
            that.loadEvents();
        }
        
    }

    loadEvents() {
        var that = this;
        this.page++;

        if(this.filterForm == undefined || (!this.filterStartDate.val().length && !this.filterEndDate.val().length) || (!this.filterStartDate.val().length && !this.filterForm.hasClass('period'))) {
            this.filtered = false;
            this.loadData = { pageId: this.page };
            this.loadDataQuery = 'all_events';
        }
        else {
            this.filtered = true;

            if(!this.filterForm.hasClass('period')) {
                this.loadData = {
                    pageId: this.page,
                    single: 1,
                    start: this.filterStartDate.val()
                };

                this.loadDataQuery = 'single_' + this.filterStartDate.val();
            }
            else {
                this.loadData = {
                    pageId: this.page,
                    single: 0,
                    start: this.filterStartDate.val(),
                    end: this.filterEndDate.val()
                };

                this.loadDataQuery = 'period_' + this.filterStartDate.val() + '_' + this.filterEndDate.val();
            }
        }

        that.loader.show();
        that.buttonMore.hide();

        $.ajax({
            url: that.url,
            dataType: 'json',
            method: 'post',
            async: false,
            data: this.loadData,

            success: function(data) {
                if(data.events == undefined || data.events.length == 0) {
                    if(that.page == 1) that.message.show();

                    that.loader.hide().removeClass('reset');
                    that.buttonMore.hide();
                    that.unlock();

                    return false;
                }

                window.setTimeout(function() {
                    $.each(data.events, function(key, value) {
                        $(value).appendTo(that.list);
                    });

                    that.loader.hide().removeClass('reset');
                    that.message.hide();
                    that.unlock();

                    if(that.page < 3) {
                        $(window).bind('scroll', { eventsList: that }, that.scrollHandler);
                    }
                    else {
                        that.buttonMore.css('display', 'block');
                    }
                }, 500);
            },
            error: function(e) {
                console.log(e);
            }
        });
    }
}

export { EventsList }
